import { useState } from 'react'
import useSubmitLock from 'hooks/use-submit-lock'
import { Link } from 'react-router-dom'
import logo from '../../../assets/images/logo.png'
import './signup.page.css'
import { useAuth, useLoginForm } from '../auth.hooks'
import { LoadingButton } from '@mui/lab'
import { FormProvider } from 'react-hook-form'
import { Alert, Snackbar, Stack } from '@mui/material'
import TextInputField from '../../../components/fields/text-input-field/text-input-field.component'
import CheckEmailView from '../check-email/check-email.page'

const SignupPage = () => {
  const formMethods = useLoginForm()
  const [registeredEmail, setRegisteredEmail] = useState<string | null>(null)

  const { isSubmitting, wrapFormSubmit } = useSubmitLock()

  const {
    handleSignup,
    isRegisterLoading,
    registerError,
    registerErrorOpen,
    setRegisterErrorOpen,
  } = useAuth()

  if (registeredEmail) {
    return <CheckEmailView email={registeredEmail} />
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Welcome</h1>
        <img src={logo} alt="Transpots Logo" className="logo" />
        <FormProvider {...formMethods}>
          <form
            onSubmit={wrapFormSubmit(formMethods.handleSubmit, async (data) => {
              const result = await handleSignup(data)
              if (result.success) {
                setRegisteredEmail(result.email)
              }
            })}
          >
            <Stack spacing={2} sx={{ width: '320px' }}>
              <TextInputField
                name="username"
                placeholder="Email"
                type="email"
                variant="standard"
              />
              <TextInputField
                name="password"
                placeholder="Password"
                type="password"
                variant="standard"
              />
              <LoadingButton
                variant="contained"
                fullWidth
                loading={isRegisterLoading || isSubmitting}
                disabled={isRegisterLoading || isSubmitting}
                sx={{
                  borderRadius: '4px',
                  '&.Mui-disabled': {
                    bgcolor: 'action.disabledBackground',
                    color: 'action.disabled',
                  },
                }}
                type="submit"
              >
                SIGNUP
              </LoadingButton>
            </Stack>
          </form>
        </FormProvider>

        <div className="form-footer">
          <Link to="/auth/login">Sign In</Link>
        </div>
      </div>

      <Snackbar
        open={registerErrorOpen}
        autoHideDuration={6000}
        onClose={() => setRegisterErrorOpen(false)}
      >
        <Alert severity="error">{registerError}</Alert>
      </Snackbar>
    </div>
  )
}

export default SignupPage
